const DOC_TYPE_LABELS: Record<string, string> = {
  AADHARCARD: "Aadhaar Card",
  PANCARD: "PAN Card",
  PPSIZEPHOTO: "Passport-Size Photo",
  METRIC: "10th Marksheet",
  HIGHERSECONDARY: "12th Marksheet",
  BACHELOR_DEGREE: "Bachelor's Degree",
  MASTER_DEGREE: "Master's Degree",
  EXPCERTIFICATE: "Experience Letter",
  FRESHERSCERTIFICATE: "Fresher's Certificate",
  INSURANCECARD: "Insurance Card",
  PASSPORT: "Passport",
  DL: "Driving Licence",
  BANK: "Bank Details",
};

export function formatDocTypeLabel(docType: string | undefined): string {
  if (docType == null || docType === "") return "Document";
  const key = docType.toUpperCase().replace(/\s+/g, "");
  if (DOC_TYPE_LABELS[key]) return DOC_TYPE_LABELS[key];
  return docType
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function normalizeDocumentStatus(status: string | undefined): string {
  const s = (status ?? "").toLowerCase();
  if (s === "approved") return "APPROVED";
  if (s.includes("reject")) return "REJECTED";
  if (s.includes("pending") || s.includes("submitted")) return "PENDING";
  return (status ?? "").toUpperCase();
}

export function isDocumentPending(status: string | undefined): boolean {
  const u = normalizeDocumentStatus(status);
  return u === "PENDING" || u === "SUBMITTED";
}

export function isDocumentApproved(status: string | undefined): boolean {
  return normalizeDocumentStatus(status) === "APPROVED";
}
